import Phaser from 'phaser';
import Player, { preload as preloadPlayer } from '../../objects/test/Player';

export default class PlayerObject extends Phaser.Scene {
  constructor() {
    super({ key: 'PlayerObject', active: true });
  }

  preload() {
    this.load.setBaseURL('/assets/test/');

    preloadPlayer.call(this);
  }

  create() {
    this.physics.world.setBoundsCollision(true);

    this.player = new Player({
      scene: this,
      x: this.game.config.width / 2,
      y: this.game.config.height / 2,
    });
  }
}
